const state = {
  mensagem: null,
  tipo: null,
}
const mutations = {
  ADICIONAR_MENSAGEM(state, data) {
    state.mensagem = data.mensagem
    state.tipo = data.tipo
  },
  LIMPAR_MENSAGEM(state) {
    state.mensagem = null
    state.tipo = null
  },
}
const actions = {
  showSucesso({ commit }, mensagem) {
    commit("ADICIONAR_MENSAGEM", { mensagem, tipo: "success" })
  },
  showErro({ commit }, mensagem) {
    commit("ADICIONAR_MENSAGEM", { mensagem, tipo: "error" })
  },
  adicionarMensagem({ commit }, data) {
    commit("ADICIONAR_MENSAGEM", data)
  },
  limparMensagem({ commit }) {
    commit("LIMPAR_MENSAGEM")
  },
}
const getters = {
  mensagem(state) {
    return state.mensagem
  },
  tipo(state) {
    return state.tipo
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
